/**
 * Unsaved Changes Guard
 * Prevents navigation away from a component with unsaved changes.
 * Components must implement the CanDeactivateComponent interface.
 */

import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MESSAGE_KEYS } from '../../shared/constants';
import { CanDeactivateComponent } from '../models/guards.types';

export const unsavedChangesGuard: CanDeactivateFn<CanDeactivateComponent> = (
  component: CanDeactivateComponent
): boolean | Promise<boolean> => {
  if (!component.canDeactivate) {
    return true;
  }

  const result = component.canDeactivate();

  if (typeof result === 'boolean' && result) {
    return true;
  }

  const messageKey = component.unsavedChangesMessageKey ?? MESSAGE_KEYS.OPERATIONS.UNSAVED_CHANGES;

  if (typeof result === 'boolean' && !result) {
    const translateService = inject(TranslateService);
    const message = translateService.instant(messageKey);
    return confirm(message);
  }

  // Handle Promise<boolean>
  return Promise.resolve(result).then(canLeave => {
    if (canLeave) {
      return true;
    }
    const translateService = inject(TranslateService);
    const message = translateService.instant(messageKey);
    return confirm(message);
  });
};
